import React, { useState } from "react";
import Header from "../../components/layout/Header";
import BottomBar from "../../components/staxs/BottomBar";
import STAXS from "../../assets/stax.png";
import staxDigitalAsset from "../../assets/staxsDigitalAsset.jpg";
import {
  HiWallet,
  HiSparkles,
  HiArrowUpRight,
  HiArrowDownLeft,
  HiEye,
  HiEyeSlash,
} from "react-icons/hi2";

const STAXSPage: React.FC = () => {
  const [showBalance, setShowBalance] = useState(true);
  const [activeTab, setActiveTab] = useState<"crypto" | "mints" | "history">(
    "crypto"
  );

  // Dummy data for demonstration
  const walletBalance = {
    total: 2847.32,
    stax: 2500.0,
    eth: 3.45,
    btc: 0.125,
  };

  const transactions = [
    {
      id: 1,
      type: "received",
      asset: "STAX",
      amount: 150.0,
      from: "0x742d...8f3a",
      timestamp: "2024-12-04T10:30:00Z",
      status: "completed",
      hash: "0xabc123...def456",
    },
    {
      id: 2,
      type: "sent",
      asset: "ETH",
      amount: 0.5,
      to: "0x123a...9b2c",
      timestamp: "2024-12-03T15:45:00Z",
      status: "completed",
      hash: "0x789xyz...123abc",
    },
    {
      id: 3,
      type: "mint",
      asset: "STAX",
      amount: 500.0,
      timestamp: "2024-12-02T09:15:00Z",
      status: "completed",
      hash: "0xmint12...345def",
    },
    {
      id: 4,
      type: "received",
      asset: "BTC",
      amount: 0.025,
      from: "bc1qxy2k...gp2ws",
      timestamp: "2024-12-01T14:20:00Z",
      status: "completed",
      hash: "0xbtc789...456ghi",
    },
  ];

  const digitalAssets = [
    {
      id: 1,
      symbol: "STAX",
      name: "STAX Token",
      balance: 2500.0,
      value: 7500.0,
      change24h: 5.2,
      icon: "S",
    },
    {
      id: 2,
      symbol: "ETH",
      name: "Ethereum",
      balance: 3.45,
      value: 4140.0,
      change24h: -2.1,
      icon: "E",
    },
    {
      id: 3,
      symbol: "XRP",
      name: "XRP",
      balance: 1250.0,
      value: 875.0,
      change24h: 3.7,
      icon: "X",
    },
  ];

  const sportsMoments = [
    {
      id: 1,
      title: "LeBron James Dunk",
      sport: "Basketball",
      player: "LeBron James",
      team: "Los Angeles Lakers",
      date: "2024-11-15",
      rarity: "Legendary",
      serialNumber: "23/100",
      value: 1250.0,
      image: "BB",
      description: "Game-winning dunk against Boston Celtics",
    },
    {
      id: 2,
      title: "Messi Free Kick Goal",
      sport: "Soccer",
      player: "Lionel Messi",
      team: "Inter Miami",
      date: "2024-10-28",
      rarity: "Epic",
      serialNumber: "10/250",
      value: 850.0,
      image: "SC",
      description: "Stunning free kick in MLS Cup playoffs",
    },
    {
      id: 3,
      title: "Mahomes Touchdown Pass",
      sport: "Football",
      player: "Patrick Mahomes",
      team: "Kansas City Chiefs",
      date: "2024-12-01",
      rarity: "Rare",
      serialNumber: "15/500",
      value: 425.0,
      image: "FB",
      description: "50-yard touchdown pass in overtime",
    },
    {
      id: 4,
      title: "Ohtani Home Run",
      sport: "Baseball",
      player: "Shohei Ohtani",
      team: "Los Angeles Dodgers",
      date: "2024-09-22",
      rarity: "Epic",
      serialNumber: "17/250",
      value: 675.0,
      image: "BS",
      description: "Walk-off grand slam in World Series",
    },
    {
      id: 5,
      title: "McDavid Hat Trick",
      sport: "Hockey",
      player: "Connor McDavid",
      team: "Edmonton Oilers",
      date: "2024-11-08",
      rarity: "Rare",
      serialNumber: "97/500",
      value: 320.0,
      image: "HK",
      description: "Natural hat trick in Stanley Cup playoffs",
    },
    {
      id: 6,
      title: "Djokovic Match Point",
      sport: "Tennis",
      player: "Novak Djokovic",
      team: "Serbia",
      date: "2024-07-14",
      rarity: "Legendary",
      serialNumber: "1/100",
      value: 1800.0,
      image: "TN",
      description: "Championship point at Wimbledon final",
    },
  ];

  const formatDate = (timestamp: string) => {
    return new Date(timestamp).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="w-full pt-16 min-h-screen">
      <Header />
      <div className="container max-w-2xl mx-auto py-8 pb-0 px-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <img src={STAXS} alt="STAX Logo" className="w-32 mr-3" />
          </div>
          WALLET
        </div>

        {/* Wallet Balance Card */}
        <div className="bg-gradient-to-br from-indigo-600 to-purple-700 rounded-2xl p-6 text-white mb-6 shadow-lg">
          <div className="flex items-center justify-between mb-4">
            <div className="gap-2">
              <h2 className="text-lg font-semibold">Wallet Balance</h2>
              <p className="text-sm text-indigo-300">
                WALLET00ADDRESSXXXXXXXXX
              </p>
            </div>
            <button
              onClick={() => setShowBalance(!showBalance)}
              className="p-2 hover:bg-base-100/20 rounded-lg transition-colors"
            >
              {showBalance ? (
                <HiEyeSlash className="w-5 h-5" />
              ) : (
                <HiEye className="w-5 h-5" />
              )}
            </button>
          </div>

          <div className="mb-0">
            <p className="text-sm opacity-80 mb-1">Total Portfolio Value</p>
            <p className="text-3xl font-bold font-grotesk">
              {showBalance
                ? `$${walletBalance.total.toLocaleString()}`
                : "******"}
            </p>
          </div>
        </div>

        {/* Digital Assets */}
        <div className="bg-base-100 rounded-2xl shadow-sm mb-6">
          <div className="p-6 border-b border-base-200">
            {/* Tab Navigation */}
            <div className="flex gap-2">
              <button
                onClick={() => setActiveTab("crypto")}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  activeTab === "crypto"
                    ? "bg-neutral text-neutral-content"
                    : "bg-base-200 text-base-content/70 hover:bg-base-300"
                }`}
              >
                Crypto
              </button>
              <button
                onClick={() => setActiveTab("mints")}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  activeTab === "mints"
                    ? "bg-neutral text-neutral-content"
                    : "bg-base-200 text-base-content/70 hover:bg-base-300"
                }`}
              >
                Mints
              </button>
              <button
                onClick={() => setActiveTab("history")}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  activeTab === "history"
                    ? "bg-neutral text-neutral-content"
                    : "bg-base-200 text-base-content/70 hover:bg-base-300"
                }`}
              >
                History
              </button>
            </div>
          </div>

          {/* Crypto Tab */}
          {activeTab === "crypto" && (
            <div className="divide-y divide-base-200">
              {digitalAssets.map((asset) => (
                <div
                  key={asset.id}
                  className="p-4 hover:bg-base-200 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-base-200 rounded-full flex items-center justify-center text-lg">
                        {asset.icon}
                      </div>
                      <div>
                        <p className="font-bold font-grotesk text-base-content">
                          {asset.symbol}
                        </p>
                        <p className="text-sm text-base-content/60">
                          {showBalance
                            ? asset.balance.toLocaleString()
                            : "****"}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-base-content">
                        {showBalance
                          ? `$${asset.value.toLocaleString()}`
                          : "****"}
                      </p>
                      <div className="flex items-center justify-end gap-2">
                        <span
                          className={`text-xs px-2 py-1 rounded-full ${
                            asset.change24h >= 0
                              ? "bg-green-500/10 text-green-600"
                              : "bg-red-500/10 text-red-600"
                          }`}
                        >
                          {asset.change24h >= 0 ? "+" : ""}
                          {asset.change24h}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Mints Tab */}
          {activeTab === "mints" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
              {sportsMoments.map((moment) => (
                <div
                  key={moment.id}
                  className="bg-base-200 rounded-xl overflow-hidden hover:bg-base-200 transition-colors cursor-pointer"
                >
                  {/* Large Image at Top */}
                  <div className="w-full h-48 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center overflow-hidden">
                    <img
                      src={staxDigitalAsset}
                      alt={moment.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Content Below Image */}
                  <div className="p-4">
                    <div className="flex items-start justify-between mb-2">
                      <h4 className="font-semibold text-base-content text-sm truncate flex-1">
                        {moment.title}
                      </h4>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ml-2 ${
                          moment.rarity === "Legendary"
                            ? "bg-gradient-to-r from-yellow-400 to-orange-500 text-white"
                            : moment.rarity === "Epic"
                            ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
                            : "bg-gradient-to-r from-blue-500 to-cyan-500 text-white"
                        }`}
                      >
                        {moment.rarity}
                      </span>
                    </div>

                    <p className="text-xs text-base-content/60 mb-3">
                      {moment.player} • {moment.team}
                    </p>

                    <div className="flex items-center justify-between">
                      <p className="text-xs text-base-content/50">
                        #{moment.serialNumber}
                      </p>
                      <p className="text-sm font-semibold text-base-content">
                        {showBalance
                          ? `$${moment.value.toLocaleString()}`
                          : "****"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* History Tab */}
          {activeTab === "history" && (
            <div className="divide-y divide-base-200">
              {transactions.map((transaction) => (
                <div key={transaction.id} className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center ${
                          transaction.type === "received" ||
                          transaction.type === "mint"
                            ? "bg-green-500/15"
                            : "bg-red-500/15"
                        }`}
                      >
                        {transaction.type === "received" ||
                        transaction.type === "mint" ? (
                          <HiArrowDownLeft className="w-5 h-5 text-green-600" />
                        ) : (
                          <HiArrowUpRight className="w-5 h-5 text-red-600" />
                        )}
                      </div>
                      <div>
                        <p className="font-medium text-base-content capitalize">
                          {transaction.type} {transaction.asset}
                        </p>
                        <p className="text-sm text-base-content/60">
                          {formatDate(transaction.timestamp)}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p
                        className={`font-medium ${
                          transaction.type === "received" ||
                          transaction.type === "mint"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {transaction.type === "received" ||
                        transaction.type === "mint"
                          ? "+"
                          : "-"}
                        {transaction.amount} {transaction.asset}
                      </p>
                      <p className="text-sm text-base-content/60 capitalize">
                        {transaction.status}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Bottom spacing for fixed bottom bar */}
        <div className="h-24"></div>
      </div>

      {/* STAX Bottom Navigation Bar */}
      <BottomBar />
    </div>
  );
};

export default STAXSPage;
